import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: people.Staff.
export default class Staff extends Fragment {
  declare [Type]: 'people/staff';

  @attr('string', { defaultValue: '' })
  declare schoolId: string;
}
